import _ from 'underscore';

import {
    ADD_NOTIFICATION,
    FLUSH_NOTIFICATIONS,
    REMOVE_NOTIFICATION,
    HIDE_NOTIFICATIONS_CENTER,
    SHOW_NOTIFICATIONS_CENTER,
} from '../constants/NotificationsActions';

function NotificationsReducer(
    state = {
        notifications: [],
        notificationsCenterDisplayed: false,
    },
    action,
) {
    switch (action.type) {
        case ADD_NOTIFICATION:
            const newNotification = {
                id: action.payload.id || Math.random().toString(32).slice(2),
                message: action.payload.message,
                bulkName: action.payload.bulkName || 'Général',
                state: action.payload.state || 'pending',
                delay: action.payload.delay || 10 * 1000,
                date: new Date(),
            };
            // Remove notification with the same ID
            const newNotifications = _.reject(state.notifications, (notification) => (
                notification.id === action.payload.id
            ));
            return {
                ...state,
                notifications: _.union(newNotifications, [newNotification]),
            };
        case REMOVE_NOTIFICATION:
            return {
                ...state,
                notifications: _.reject(state.notifications, (notification) => (
                    notification.id === action.payload.id
                )),
            };
        case FLUSH_NOTIFICATIONS:
            return {
                ...state,
                notifications: [],
            };
        case HIDE_NOTIFICATIONS_CENTER:
            return {
                ...state,
                notificationsCenterDisplayed: false,
            };
        case SHOW_NOTIFICATIONS_CENTER:
            return {
                ...state,
                notificationsCenterDisplayed: true,
            };
        default:
            return state;
    }
}

export default NotificationsReducer;
